<div class="save_button">
  <svg class="icon_save">
    <use xlink:href="images/sprites5.svg#icon-floppy-o"></use>
  </svg>
  <div class="button_title" (click)="onSave()">Save</div>
</div>
